import styled from 'styled-components';

interface ContainerProps {
  pathFlag?: boolean;
}

const Container = styled.div<ContainerProps>`
  max-width: ${(props) => {
    if (props.pathFlag) {
      return `100%`;
    } else {
      return `72rem`;
    }
  }};
  height: ${(props) => {
    if (props.pathFlag) {
      return `100%`;
    }
  }};
  margin-left: ${(props) => {
    if (props.pathFlag) {
      return `0`;
    } else {
      return `auto`;
    }
  }};
  margin-right: ${(props) => {
    if (props.pathFlag) {
      return `0`;
    } else {
      return `auto`;
    }
  }};
`;

export default Container;
